import { importTimesheet, importTimesheets } from '../../services/jiraSync';
import { defaultActivePhaseId, phaseBrickId } from '../../utils/phases';

// Worklog prêt à importer : membre choisi, et brique ou phase choisie.
export const isReadyToImport = (e) => e.remapDevId && (e.remapBriqueId || e.remapPhaseId);

const remappedRow = (e, dev, briqueId) => ({
  user_id: dev.id,
  dev_id: dev.dev_id || dev.id,
  date: e.date,
  brique_id: briqueId,
  heures: e.hours,
  note: 'Import Jira (remappé)',
});

// Changement d'un champ de rattachement : choisir un client propose sa phase active et vide la
// brique ; choisir une phase vide la brique.
function remapChange(x, field, value, clients) {
  if (field === 'remapClientId') {
    const c = (clients || []).find((cl) => cl.id === value);
    return {
      ...x,
      remapClientId: value,
      remapPhaseId: c ? defaultActivePhaseId(c) : '',
      remapBriqueId: '',
    };
  }
  if (field === 'remapPhaseId') return { ...x, remapPhaseId: value, remapBriqueId: '' };
  return { ...x, [field]: value };
}

/* Worklogs Jira non rattachés après une synchro complète : rattachement manuel puis import (un
   par un ou tous ceux qui sont prêts). Le rattachement est mémorisé pour les prochaines synchros. */
export default function jiraUnmatchedHandlers(deps, api) {
  const { adminUsers, setYearImportModal, appState, yearImportModal } = deps;

  const updateUnmatched = (i, field, value) =>
    setYearImportModal((m) => ({
      ...m,
      unmatched: m.unmatched.map((x, j) =>
        j !== i ? x : remapChange(x, field, value, appState.clients),
      ),
    }));

  // Compte les heures importées et retire les worklogs traités de la liste.
  const imported = (data, keep) => {
    setYearImportModal((m) => ({
      ...m,
      inserted: (m.inserted || 0) + data.inserted,
      unmatched: keep(m),
    }));
    api.loadHoursByBrick();
  };

  async function handleIncludeYear(e, i) {
    const dev = adminUsers.find((u) => u.id === e.remapDevId);
    if (!dev) return;
    const briqueId = e.remapBriqueId || (e.remapPhaseId ? phaseBrickId(e.remapPhaseId) : null);
    if (!briqueId) return;
    const { data } = await importTimesheet(remappedRow(e, dev, briqueId));
    if (!data || data.error) return;
    api.saveJiraIssueKeyMap([{ issueKey: e.issueKey, user_id: dev.id, brique_id: briqueId }]);
    imported(data, (m) => m.unmatched.filter((_, j) => j !== i));
  }

  async function handleImportAllReady() {
    const ready = (yearImportModal.unmatched || []).filter(isReadyToImport);
    if (!ready.length) return;
    const rows = ready.map((e) =>
      remappedRow(
        e,
        adminUsers.find((u) => u.id === e.remapDevId),
        e.remapBriqueId || phaseBrickId(e.remapPhaseId),
      ),
    );
    const { data } = await importTimesheets(rows);
    if (!data || data.error) return;
    api.saveJiraIssueKeyMap(
      ready.map((e, idx) => ({
        issueKey: e.issueKey,
        user_id: e.remapDevId,
        brique_id: rows[idx].brique_id,
      })),
    );
    imported(data, (m) => (m.unmatched || []).filter((e) => !isReadyToImport(e)));
  }

  return { updateUnmatched, handleIncludeYear, handleImportAllReady };
}
